/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './Title.scss';

import React from 'react';

const _renderTitle = (title) => {
    if (title) {
        return (<h2 className="title">{title}</h2>);
    }
};

const _renderSubTitle = (subTitle) => {
    if (subTitle) {
        return (<div className="sub-title">{subTitle}</div>);
    }
};

const Title = ({ mainTitle, subTitle }) => {
    return (
        <div id="title-info" className="title-info">
            {_renderTitle(mainTitle)}
            {_renderSubTitle(subTitle)}
        </div>
    );
};

export default Title;